var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("line", {
  x1: 7,
  y1: 11,
  x2: 7,
  y2: 43,
  stroke: "#FFD200",
  strokeWidth: 2
});
var _ref3 = /*#__PURE__*/React.createElement("line", {
  x1: 12,
  y1: 11,
  x2: 12,
  y2: 43,
  stroke: "#FFD200",
  strokeWidth: 2
});
var _ref4 = /*#__PURE__*/React.createElement("line", {
  x1: 36,
  y1: 11,
  x2: 36,
  y2: 43,
  stroke: "#FFD200",
  strokeWidth: 2
});
var _ref5 = /*#__PURE__*/React.createElement("line", {
  x1: 41,
  y1: 11,
  x2: 41,
  y2: 43,
  stroke: "#FFD200",
  strokeWidth: 2
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M47 14.95C47 12.2275 44.8586 10 42.2414 10H5.75862C3.14138 10 1 12.2275 1 14.95V38.05C1 40.7725 3.14138 43 5.75862 43H42.2414C44.8586 43 47 40.7725 47 38.05V14.95Z",
  stroke: "#C5CAD1",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M14 10V7C14 5.35 15.9 4 18.2222 4H28.7778C31.1 4 33 5.35 33 7V10",
  stroke: "#FFD200",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 5,
  y: 20,
  width: 18,
  height: 5,
  rx: 1,
  transform: "rotate(-13.3317 5 20)",
  fill: "#FFD200"
});
function SvgBaggage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaggage);
export default __webpack_public_path__ + "static/media/baggage.6c7ae4ad.svg";
export { ForwardRef as ReactComponent };